import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import {
  Button,
  Input,
  Dialog,
  Radio,
  Toast,
  LoginLayout,
  Icon
} from "@app/components";
import {
  FormFlexWrapper,
  DropdownWrapper,
  SelectCustomStyles,
  Error,
  CommonLabel,
  FlexWrapper,
} from "@app/components/commonStyles";
import { ThankYouParent } from "@app/assets";
import { stateList, user, useLocation, capitalize } from "@app/utils";
import { educatorSchoolAcount, getAddress } from "@app/services";
import { AuthContext } from "@app/providers";
import {
  ButtonContainer,
  ThankyouContainer,
  ThankyouImageContainer,
  ThankyouText,
} from "../sign-up.component";
import { PopUpContainer, PopUpSubTitle, PopUpText, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";

const licenseTypes = [
  { label: "District", value: "district" },
  { label: "School", value: "school" },
];

type Props = {
  educatorData: any;
};

export default function EducatorDistrictOrSchoolAccount({
  educatorData,
}: Props) {
  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    clearErrors,
  }: any = useForm({
    mode: "onSubmit",
    defaultValues: {
      licenseType: "district",
    },
  });
  const { navigate } = useLocation();
  const [licenseType, setLicenseType] = useState<string>("district");
  const [showThankyou, setShowThankyou] = useState<boolean>(false);
  const [buttonText, setbuttonText] = useState<string>("Submit");
  const [zipError, setZipError] = useState<boolean>(false);
  const [showToast, setShowToast] = useState(false);
  const { setUserInfo } = useContext(AuthContext);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });

  const [districtData, setDistrictData] = useState<any>()
  function onSubmit(data: any) {
    setbuttonText("Submitting...");
    let DistrictData: any = localStorage.getItem('data');
    DistrictData = DistrictData ? DistrictData : null;
    const params: any = {};
    Object.assign(params, {
      sessionToken: user.sessionToken,
      userId: user.userId,
      userType: "educator",
      kazooLicenseFor: data.licenseType,
      classRoomsInSchool: data.numOfClasses,
      studentsInSchool: data.numOfStudents,
      schoolName: data.schoolName,
      schoolCity: data.schoolCity,
      schoolState: data.schoolState.value,
      schoolZip: data.schoolZip,
      firstName: localStorage.getItem("firstName"),
      lastName: localStorage.getItem("lastName"),
      phoneNumber: localStorage.getItem("phoneNumber"),
      email: localStorage.getItem("email"),
      city: localStorage.getItem("city"),
      state: localStorage.getItem("state"),
      zip: localStorage.getItem("zip"),
      kazooAmbassador: localStorage.getItem("ambassador") ? 1 : 0,
      termsOfService: 1,
    });
    if (data.licenseType === "district") {
      Object.assign(params, {
        schoolsInDistrict: data.numOfSchools,
      });
    }
    educatorSchoolAcount(params)
      .then((resp) => {
        const response = resp.data;
        if (!response._responseStatus) {
          setShowThankyou(false);
        }
        if (resp.status === 200 && response._responseStatus) {
          // localStorage.removeItem('data')
          setbuttonText("Submit");
          setShowThankyou(true);
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setbuttonText("Submit");
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setbuttonText("Submit");
        console.log(err, "signupError");
      });
  }

  function onChange(data: any) {
    if (data.target.name === "licenseType") {
      setLicenseType(data.target.value);
    }
    if (data.target.name === "schoolZip") {
      setValue("schoolCity", "");
      setValue("schoolState", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }
  function onZipBlur(data: any) {
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("schoolCity", capitalize(res.city));
          clearErrors("schoolCity");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("schoolState", selectedState);
          clearErrors("schoolState");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <LoginLayout label="" path="">
      <h3 className="primary-header text-center mb-3">
        District/School Account
      </h3>
      <form onChange={onChange} onSubmit={handleSubmit(onSubmit)}>
        <h4 className="secondary-header mb-10">Schools Details</h4>
        <FormFlexWrapper className="mb-0">
          <div className="child only-child">
            <Input
              label="School Name"
              placeholder="School Name"
              name="schoolName"
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.schoolName && "Please enter School Name"}
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="mb-0">
          <div className="child only-child">
            <Input
              type="number"
              label="Zip Code"
              placeholder="Zip Code"
              name="schoolZip"
              onBlur={onZipBlur}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={
                (errors.schoolZip && "Please enter Zip Code") ||
                (!errors.schoolZip && zipError && "Please enter valid Zip Code")
              }
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="two-child-layout mb-0">
          <div className="child mb-0">
            <Input
              label="City"
              placeholder="City"
              name="schoolCity"
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.schoolCity && "Please enter City"}
            />
          </div>
          <div className="child">
            <CommonLabel className="label-color">State</CommonLabel>
            <DropdownWrapper>
              <Controller
                as={Select}
                value="value"
                name="schoolState"
                options={stateList}
                placeholder="State"
                control={control}
                rules={{ required: true }}
                styles={SelectCustomStyles}
                defaultValue={""}
              />
              {errors.schoolState && <Error>Please select State</Error>}
            </DropdownWrapper>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel className="label-color">Purchase License for District/School</CommonLabel>
            <FlexWrapper>
              {licenseTypes.map((each: any, index: number) => (
                <Radio
                  className="radio mr-3"
                  name="licenseType"
                  value={each.value}
                  key={each.value}
                  checked={true}
                  register={register({
                    required: true,
                  })}
                  id={"licenseType_" + each.value}
                  label={each.label}
                />
              ))}
            </FlexWrapper>
            {errors.licenseType && (
              <Error>Please select License for District/School</Error>
            )}
          </div>
        </FormFlexWrapper>
        {licenseType === "district" && (
          <div id="districtDetails">
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="How many schools in District?"
                  placeholder="Enter number of schools available in the District"
                  name="numOfSchools"
                  maxLength={3}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={
                    errors.numOfSchools &&
                    " Please enter number of schools available in the District"
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="How many classrooms in your District?"
                  placeholder="Enter number of classrooms in your District"
                  name="numOfClasses"
                  maxLength={4}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={
                    errors.numOfClasses &&
                    "Please enter number of classrooms in your District"
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="How many students in your District?"
                  placeholder="Enter number of students in your District"
                  maxLength={5}
                  name="numOfStudents"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={
                    errors.numOfStudents &&
                    " Please enter number of students in your District"
                  }
                />
              </div>
            </FormFlexWrapper>
          </div>
        )}
        {licenseType === "school" && (
          <div id="schoolDetails">
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="How many classrooms in your School?"
                  placeholder="Enter number of classrooms in your School"
                  name="numOfClasses"
                  maxLength={2}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={
                    errors.numOfClasses &&
                    "Please enter number of classrooms in your School"
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <Input
                  hideLabel={false}
                  type="number"
                  label="How many students in your School?"
                  placeholder="Enter number of students in your School"
                  name="numOfStudents"
                  maxLength={4}
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value.trim().length > 0;
                    },
                  })}
                  error={
                    errors.numOfStudents &&
                    "Please enter number of students in your School"
                  }
                />
              </div>
            </FormFlexWrapper>
          </div>
        )}
        <ButtonContainer className="mb-sm-1" disabled={buttonText === "Submitting..."}>
          <Button variant="newsecondary" width={"100%"} type="submit" size="large">
            {buttonText}
          </Button>
        </ButtonContainer>
        <Button variant="bordered" width="100%" size="large" onClick={() => navigate("/")} style={{ marginTop: '16px' }}>
          Cancel
        </Button>
      </form>
      {showThankyou && (
        <PopUpWrapper>
          <PopUpContainer>
            <Icon name="signsuccess" />
            <span className="close-icon" onClick={() => navigate("/sign-in/educator")}>
              <Icon name="close" />
            </span>
            <PopUpTitle>Sign up completed!</PopUpTitle>
            <PopUpSubTitle>
              Thank you for signing up kazoobadoo
            </PopUpSubTitle>
            <PopUpText>Please check your inbox and click on the verification link to verify your account</PopUpText>
          </PopUpContainer>
        </PopUpWrapper>
      )}
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        onClose={() => setShowToast(false)}
      />
    </LoginLayout>
  );
}
